import { render, staticRenderFns } from "./PaymentMethodForm.vue?vue&type=template&id=6e204f08&scoped=true"
import script from "./PaymentMethodForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e204f08",
  null
  
)

export default component.exports